<template>
  <v-dialog v-model="dialog" scrollable width="500">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon v-if="update">settings</v-icon>
        <v-icon v-if="add">add</v-icon>
      </v-btn>
    </template>

    <v-card height="500px">
      <v-card-title
        v-if="add"
        class="headline grey lighten-2"
        primary-title
      >{{$t('DeviceTypes.Dialog.property-title-add')}}</v-card-title>
      <v-card-title
        v-if="update"
        class="headline grey lighten-2"
        primary-title
      >{{$t('DeviceTypes.Dialog.property-title-update')}}</v-card-title>

      <v-card-text>
        <br />
        <v-alert
          type="error"
          transition="scale-transition"
          v-model="alert"
          border="left"
          dismissible
        >{{alertMsg}}</v-alert>

        <v-form v-model="valid">
          <div class="text-subtitle-2 mb-2" v-text="$t('DeviceTypes.property')"></div>
          <v-text-field :rules="[rules.required]" solo v-model="property"></v-text-field>

          <div class="text-subtitle-2 mb-2" v-text="$t('DeviceTypes.type')"></div>
          <v-select
            :rules="[rules.required]"
            :items="['String','Number','Boolean','Object']"
            v-model="type"
            solo
          ></v-select>

          <div class="text-subtitle-2 mb-2" v-text="$t('DeviceTypes.description')"></div>
          <v-textarea
            clearable
            clear-icon="cancel"
            v-model="description"
            solo
            no-resize
            height="150px"
          ></v-textarea>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="primary" text @click="deleteProperty">{{$t('DeviceTypes.delete')}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false">{{$t('DeviceTypes.back')}}</v-btn>
        <v-btn color="primary" text @click="save">{{$t('DeviceTypes.save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  props: {
    update: Boolean,
    add: Boolean,
    prop: Object,
    deviceTypeId: String
  },
  data() {
    return {
      dialog: false,
      property: "",
      type: "",
      description: "",
      valid: false,
      rules: {
        required: value =>
          !!value || this.$t("Login.RegisterComponent.rules.required")
      },
      alert: false,
      alertMsg: ""
    };
  },
  watch: {
    dialog: function() {
      this.property = this.prop.property;
      this.type = this.prop.type;
      this.description = this.prop.description;
    }
  },
  methods: {
    save: function() {
      if (this.valid) {
        if (this.add) {
          axios
            .post(
              process.env.VUE_APP_API_ADDR +
                "/api/deviceType/" +
                this.deviceTypeId +
                "/property",
              {
                properties: [
                  {
                    property: this.property,
                    type: this.type.toLowerCase(),
                    description: this.description
                  }
                ]
              },
              {
                headers: { Authorization: tokenStore.getToken() }
              }
            )
            .then(res => {
              if (res.data.success) {
                this.dialog = false;
                this.$emit("propertyadded");
              }
            })
            .catch(err => {
              if (err) {
                this.alertMsg = err.response.data.errorMessage;
                this.alert = true;
              }
            });
        } else if (this.update) {
          axios
            .put(
              process.env.VUE_APP_API_ADDR +
                "/api/deviceType/" +
                this.deviceTypeId +
                "/property",
              {
                properties: [
                  {
                    oldProperty: this.prop.property,
                    newProperty: this.property,
                    type: this.type.toLowerCase(),
                    description: this.description
                  }
                ]
              },
              {
                headers: { Authorization: tokenStore.getToken() }
              }
            )
            .then(res => {
              if (res.data.success) {
                this.dialog = false;
                this.$emit("propertyupdated");
              }
            })
            .catch(err => {
              if (err) {
                this.alertMsg = err.response.data.errorMessage;
                this.alert = true;
              }
            });
        }
      } else {
        this.alertMsg = this.$t("DeviceTypes.Dialog.property-alert-form");
        this.alert = true;
      }
    },
    deleteProperty: function() {
      axios
        .delete(
          process.env.VUE_APP_API_ADDR +
            "/api/deviceType/" +
            this.deviceTypeId +
            "/property",
          {
            headers: {
              Authorization: tokenStore.getToken()
            },
            data: {
              properties: [this.property]
            }
          }
        )
        .then(res => {
          if (res.data.success) {
            this.dialog = false;
            this.$emit("propertydeleted");
          }
        })
        .catch(err => {
          if (err) {
            this.alertMsg = err.response.data.errMessage;
            this.alert = true;
          }
        });
    }
  }
};
</script>